<willow-layout>
  <perch-icons-letter-dotted role="icon"></perch-icons-letter-dotted>
  <div role="header">Estimate not found</div>
  <div>
    This home sale estimate is no longer valid.
    If you haven’t received a new estimate, contact our Customer Experience Team at
    <a href="mailto:support@orchard.com">support@orchard.com</a>.
  </div>
</willow-layout>
